import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	planOnWhiteboard: {
		id: 'backlog.whiteboards-entrypoint-experiment.plan-on-whiteboard',
		defaultMessage: 'Plan on whiteboard',
		description: 'Label for context menu action to plan on whiteboard',
	},
	planOnWhiteboardTry: {
		id: 'backlog.whiteboards-entrypoint-experiment.plan-on-whiteboard-try',
		defaultMessage: 'Try',
		description: 'Label for try lozenge',
	},
});
